// extracted by mini-css-extract-plugin
export var logo = "_99-2";
export var logoWrapper = "_99-1";
export var strip = "_99-0";